import type { TIconSizes } from "../../../assets/types/icons";
import type { BadgeSize } from "../../Badge/types";
import type { IndicatorSize } from "../../Indicator/Indicator/types";
import type { IndicatorCounterSize } from "../../Indicator/IndicatorCounter/types";
import type { TagSizes } from "../../Tag/Tag/types";
import type { AvaPictureSizes } from "../types";

export const sizes: AvaPictureSizes[] = [
    "16",
    "20",
    "24",
    "36",
    "44",
    "56",
    "72",
    "96",
    "120",
    "144",
];

export const ICON_SIZE_BY_AVA_PICTURE_SIZE_MAP: Record<
    AvaPictureSizes,
    TIconSizes["size"]
> = {
    "16": "12",
    "20": "12",
    "24": "16",
    "36": "20",
    "44": "24",
    "56": "24",
    "72": "32",
    "96": "48",
    "120": "48",
    "144": "48",
};

export const INDICATOR_SIZE_BY_AVA_PICTURE_SIZE_MAP: Partial<
    Record<AvaPictureSizes, IndicatorSize>
> = {
    "24": "8",
    "36": "12",
    "44": "12",
    "56": "12",
    "72": "16",
    "96": "20",
    "120": "24",
    "144": "24",
} as const;

export const INDICATOR_COUNTER_SIZE_BY_AVA_PICTURE_SIZE_MAP: Partial<
    Record<AvaPictureSizes, IndicatorCounterSize>
> = {
    "24": "16",
    "36": "16",
    "44": "16",
    "56": "16",
    "72": "20",
    "96": "24",
    "120": "24",
    "144": "24",
} as const;

export const TAG_SIZE_BY_AVA_PICTURE_SIZE_MAP: Partial<
    Record<AvaPictureSizes, TagSizes>
> = {
    "56": "20",
    "72": "20",
    "96": "24",
    "120": "24",
    "144": "24",
};

export const BADGE_SIZE_BY_AVA_PICTURE_SIZE_MAP: Partial<
    Record<AvaPictureSizes, BadgeSize>
> = {
    "36": "12",
    "44": "16",
    "56": "16",
    "72": "20",
    "96": "24",
    "120": "24",
    "144": "24",
};

export const GIFT_SIZE_BY_AVA_PICTURE_SIZE_MAP: Partial<
    Record<AvaPictureSizes, number>
> = {
    "56": 24,
    "72": 36,
    "96": 36,
    "120": 56,
    "144": 56,
};
